import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "antd";
import User from "models/User";
import styles from "./PlatformPageHeader.module.less";

const UserDisplay = (props) => {
  const { firstName, lastName, avatar } = props.user.props;
  const avatarSrc = avatar ? avatar.thumb : null;
  const initials = `${firstName?.charAt(0) ?? ""}${lastName?.charAt(0) ?? ""}`.toUpperCase();

  return (
    <div className={styles.userDisplay}>
      <Avatar
        className={styles.avatar}
        shape="circle"
        src={avatarSrc}
        style={avatarSrc ? { width: 34, height: 34 } : { width: 34, height: 34, background: "var(--tileGradient)" }}
      >
        {!avatarSrc && initials}
      </Avatar>
    </div>
  );
};

UserDisplay.propTypes = {
  user: PropTypes.instanceOf(User),
};

export default UserDisplay;
